/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: 356c669961f84a8b1a7a657ffbd85a6cf9f30a5114c705361f20ba50493ea4f3
 */
import cn from 'classnames'
import React, { ComponentProps, ReactElement } from 'react'

import style from './LinkText.style'

type LinkTextOwnProps = {
  className?: string
  disabled?: boolean
  variant?: 'default' | 'severe'
}

export type LinkTextProps = LinkTextOwnProps & Omit<ComponentProps<'a'>, keyof LinkTextOwnProps>

function LinkText(props: LinkTextProps): ReactElement {
  const {
    children,
    className = '',
    disabled = false,
    variant = 'default',
    ...rest
  } = props

  const {
    href,
    onClick,
    tabIndex,
    ...linkProps
  } = rest

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (disabled) {
      event.preventDefault()
      event.stopPropagation()
      return
    }

    onClick?.(event)
  }

  return (
    <a
      className={cn('LinkText', className, variant, { disabled })}
      css={style}
      {...linkProps}
      aria-disabled={disabled ? true : linkProps['aria-disabled']}
      href={disabled ? undefined : href}
      onClick={handleClick}
      role={disabled ? 'link' : linkProps.role}
      tabIndex={disabled ? -1 : tabIndex}
    >
      {children}
    </a>
  )
}

export default LinkText
